module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cutomers/cutomers.component.css
// module id = ./src/app/cutomers/cutomers.component.css
// module chunks = main